import ApiService from './api';

const SubcontractorService = {
  getDrivers: async function (id) {
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectchauffeursoa?username=${id}`;
    try {
      const res = await ApiService.get(query);
      if (res && res.status) {
        console.log('-- get subcontractor chauffeurs data ok --');
        return res.data;
      }
      console.warn('!! get subcontractor chauffeurs data invalid');
      return false;
    } catch (error) {
      console.warn('!! get subcontractor chauffeurs data error ', error);
      return false;
    }
  },

  addDriver: async function(data){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/addchauffeuroa`;
    const formData = new FormData();
    console.log(JSON.stringify(data));
    Object.keys(data).forEach( key => {
      formData.append(key, data[key]);
    });
    try {
      const res = await ApiService.post(query,formData,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
      });
      if (res && res.status) {
        console.log('-- add subcontractor chauffeur data ok --');
        return true;
      }
      else{
        console.warn('!! add subcontractor chauffeur invalid');
        return false;
      }
    } catch (error){
      console.warn('!! add subcontractor chauffeur error ',error);
      return false;
    }
  },

  editDriver: async function(data){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/editchauffeuroa`;
    const formData = new FormData();
    console.log(JSON.stringify(data));
    Object.keys(data).forEach( key => {
      formData.append(key, data[key]);
    });
    try {
      const res = await ApiService.post(query,formData,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
      });
      if (res && res.data && res.data.status) {
        console.log('-- edit subcontractor chauffeur data ok --');
        return true;
      }
      else{
        console.warn('!! edit subcontractor chauffeur invalid');
        return false;
      }
    } catch (error){
      console.warn('!! edit subcontractor chauffeur error ',error);
      return false;
    }

  },

  deleteDriver: async function(id,login){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/removechauffeuroa?chauffeurid=${id}&login=${login}`;
    try {
      const res = await ApiService.get(query)
      if (res && res.status) {
        console.log('-- delete subcontractor chauffeur data ok --');
        return true;
      }
      else{
        console.warn('!! delete subcontractor chauffeur invald');
        return false;
      }
    } catch (error){
      console.warn('!! delete subcontractor chauffeur error ',error);
      return false;
    }
  },

  getFleet: async function (id){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/selectwagensoa?username=${id}`;
    try {
      const res = await ApiService.get(query);
      if (res && res.status) {
        console.log('-- get subcontractor fleet data data ok --');
        return res.data;
      }
      console.warn('!! get subcontractor fleet data invalid');
      return false;
    } catch (error) {
      console.warn('!! get subcontractor fleed data error ', error);
      return false;
    }
  },

  addVehicle: async function(data){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/addwagenoa`;
    const formData = new FormData();
    console.log(JSON.stringify(data));
    Object.keys(data).forEach( key => {
      formData.append(key, data[key]);
    });
    try {
      const res = await ApiService.post(query,formData,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
      });
      if (res && res.status) {
        console.log('-- add subcontractor wagen data ok --');
        return true;
      }
      else{
        console.warn('!! add subcontractor wagen invalid');
        return false;
      }
    } catch (error){
      console.warn('!! add subcontractor wagen error ',error);
      return false;
    }
  },

  editVehicle: async function(data){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/editwagenoa`;
    const formData = new FormData();
    console.log(JSON.stringify(data));
    Object.keys(data).forEach( key => {
      formData.append(key, data[key]);
    });
    try {
      const res = await ApiService.post(query,formData,{
        headers:{
          'Content-Type':'multipart/form-data'
        }
      });
      if (res && res.data && res.data.status) {
        console.log('-- edit subcontractor vehicle data ok --');
        return true;
      }
      else{
        console.warn('!! edit subcontractor vehicle invalid');
        return false;
      }
    } catch (error){
      console.warn('!! edit subcontractor vehicle error ',error);
      return false;
    }
  },

  deleteVehicle: async function(id){
    const query = `${process.env.VUE_APP_ROOT_API_ENV}/partners/removewagenoa?wagenid=${id}`;
    try {
      const res = await ApiService.get(query)
      if (res && res.status) {
        console.log('-- delete subcontractor wagen data ok --');
        return true;
      }
      else{
        console.warn('!! delete subcontractor wagen invald');
        return false;
      }
    } catch (error){
      console.warn('!! delete subcontractor wagen error ',error);
      return false;
    }
  },
}

export default SubcontractorService;
